import { api } from "./api";

export interface FinancialAuditParams {
  startDate: string;
  endDate: string;
  currency?: string;
}

export interface DistributionItem {
  label: string;
  value: number;
  percentage: number;
}

export interface FinancialAuditResponse {
  summary: {
    netBalance: number;
    revenue: number;
    deductions: number;
  };
  calculation: {
    totalBilled: number;
    refunds: number;
    chargebackFees: number;
    processingFees: number;
    withdrawalFees: number;
    calculatedNetBalance: number;
  };
  distribution: DistributionItem[];
  audit: {
    calculatedBalance: number;
    registeredBalance: number;
    difference: number;
    hasDifference: boolean;
  };
}

export class FinancialAuditService {
  static async getFinancialAudit(
    params: FinancialAuditParams,
  ): Promise<FinancialAuditResponse> {
    const response = await api.get("/v1/financial-audit", {
      params: {
        start_date: params.startDate,
        end_date: params.endDate,
        currency: params.currency,
      },
    });
    return response.data.data;
  }
}
